import { createFeature, createReducer } from '@ngrx/store';

import { blueSageSettingsReducers } from './bluesage-settings.reducer';
import { blueSageSettingsInitialState } from './bluesage-settings.state';

export const blueSageSettingsFeature = createFeature({
    name: 'blueSageSettings',
    reducer: createReducer(blueSageSettingsInitialState, ...blueSageSettingsReducers),
});
